import React, { useEffect, useState, useCallback } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { loadNatalChart } from '../lib/chartStorage';
import { computeReportStructure } from '../lib/reportUtils';
import ReportContent from '../components/chart/ReportContent';
import './ChartReportPage.css';

const ChartReportPage = () => {
  const [data, setData] = useState(undefined);

  useEffect(() => {
    const stored = loadNatalChart();
    if (stored?.chartResult?.chartModel) {
      setData(stored);
    } else {
      setData(null);
    }
  }, []);

  const handlePrint = useCallback(() => {
    try {
      const printWin = window.open('/chart/report/print', '_blank', 'noopener,noreferrer');
      if (!printWin) {
        window.print();
      }
    } catch {
      window.print();
    }
  }, []);

  if (data === undefined) {
    return (
      <div className="chart-report-page chart-report-empty">
        <div className="chart-report-empty-card">
          <p>Loading report…</p>
        </div>
      </div>
    );
  }

  if (data === null || !data.chartResult?.chartModel) {
    return <Navigate to="/chart" replace />;
  }

  const { chartResult, meta } = data;
  const chart = chartResult.chartModel;
  const wheelData = chartResult.wheelData;
  const structure = computeReportStructure(chart.planets);
  const sun = chart.planets.find((p) => p.key === 'sun');
  const moon = chart.planets.find((p) => p.key === 'moon');
  const rising = chartResult.angles?.asc;
  const mc = chartResult.angles?.mc;

  return (
    <div className="chart-report-page">
      <div className="chart-report-toolbar no-print">
        <Link to="/chart" className="chart-report-back">← Back to chart</Link>
        <div className="chart-report-toolbar-actions">
          <Link to="/chart" className="chart-report-interactive-btn">Open interactive chart</Link>
          <button type="button" className="chart-report-print" onClick={handlePrint}>
            Print / Save as PDF
          </button>
        </div>
      </div>

      <ReportContent
        chartResult={chartResult}
        meta={meta}
        chart={chart}
        wheelData={wheelData}
        structure={structure}
        sun={sun}
        moon={moon}
        rising={rising}
        mc={mc}
        variant="screen"
      />
    </div>
  );
};

export default ChartReportPage;
